

import React, { useMemo, memo } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-modal';
import modalCustomStyles from '../../../../util/modalCustomStyles';
import CloseIcon from '../../../../components/icons/CloseIcon';

/**
 * Modal optimizado para mostrar opciones de ListMessageMC
 * - Usa useTranslation('InboxMC') para textos
 * - Memoiza options y handlers
 * - UI pura, sin lógica de negocio
 */
const OptionsListModalMC = memo(({ isOpen, toggleModal, options, optionTitle }) => {
  const { t } = useTranslation('InboxMC');

  // Memoizar estilos para evitar recalculo
  const customStyle = useMemo(() => ({
    width: '20%',
    height: 'auto',
    padding: '0px',
    borderRadius: '0.75rem',
    overflow: 'hidden',
  }), []);

  // Memoizar renderizado de opciones
  const renderedOptions = useMemo(() => (
    options.map((option, index) => (
      <div
        key={`list-option-${index}`}
        className="tw-mb-1 tw-py-1 tw-cursor-pointer"
      >
        <span className="tw-text-[#808191] tw-text-base">{option.title}</span>
      </div>
    ))
  ), [options]);

  return (
    <Modal
      isOpen={isOpen}
      style={modalCustomStyles(false, customStyle)}
      ariaHideApp={false}
    >
      <div className="tw-wrapper">
        <div className="tw-flex tw-items-center tw-bg-[#3CAAE1] tw-px-6 tw-py-3 tw-rounded-t-xl">
          <button
            type="button"
            className="tw-mr-3 tw-p-1"
            onClick={toggleModal}
            aria-label={t('listMessage.close')}
          >
            <CloseIcon className="tw-w-5 tw-h-5 tw-fill-white" />
          </button>
          <span className="tw-text-white tw-text-base tw-truncate">{optionTitle}</span>
        </div>
        <div className="tw-px-6 tw-py-4 tw-max-h-[70vh] tw-overflow-y-auto">
          <div className="tw-mb-3">
            <span className="tw-text-[#3CAAE1] tw-text-lg">{t('listMessage.selectOptionTitle')}</span>
          </div>
          <div>
            {renderedOptions}
          </div>
        </div>
      </div>
    </Modal>
  );
});

OptionsListModalMC.displayName = 'OptionsListModalMC';

export default OptionsListModalMC;